import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Location } from '@angular/common';
import { RoutingStateService } from 'src/app/services/routing-state.service';
import { ActivatedRoute } from "@angular/router";
import { LocalStorageService } from "src/app/services/local-storage.service";

@Component({
    selector: 'app-back-button',
    templateUrl: './back-button.component.html',
    styleUrls: ['./back-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BackButtonComponent implements OnInit {
  previousUrl: string;
  page: string;
  id: number;

  @Input() idparameter: string;
  @Input() text: string = 'Tilbage';
  @Input() altLink: string = '';
  @Input() altText: string = 'Tilbage til oversigten';

  constructor(private location: Location, private routingState: RoutingStateService, private route: ActivatedRoute,private storage:LocalStorageService) {
    this.location.subscribe(x => this.storage.set("pagination-page", {page:this.page, id:this.id}));
  }



  ngOnInit(): void {
    this.previousUrl = this.routingState.getPreviousUrl();
    this.page = this.route.snapshot.paramMap.get('page');
    this.id = Number(this.route.snapshot.paramMap.get(this.idparameter));
  }

  goback() {

    this.location.back();
  }
}
